<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center py-10>
      <v-flex xs12 sm12 md12 lg11 xl10>
        <v-card elevation="0" outlined class="rounded-lg overflow-hidden" style="background-color: #ffffff; border-color: #e0e0e0;">
          <v-tabs v-model="targetTab" color="#005f32" slider-color="#005f32" class="px-6 pt-4 target-tabs-modern">
            <v-tab href="#bulk-upload-tab" class="font-weight-bold" style="letter-spacing: 0.5px; text-transform: none; font-size: 15px;">Bulk Upload</v-tab>
            <v-tab href="#single-target-tab" class="font-weight-bold" style="letter-spacing: 0.5px; text-transform: none; font-size: 15px;">Single Target</v-tab>
          </v-tabs>
          
          <v-divider></v-divider>

          <v-tabs-items v-model="targetTab" class="pa-6 pb-8" style="background-color: transparent;">
            <v-tab-item value="bulk-upload-tab">
              <!-- Confirmation Dialog -->
              <v-dialog v-model="confirmDialog" max-width="480px">
                <v-card class="confirm-dialog-card">
                  <v-card-title class="confirm-dialog-title">
                    <v-icon left color="#e65100">mdi-alert-circle-outline</v-icon>
                    Confirm {{ isExcelFile ? 'Excel' : 'Bulk' }} Upload
                  </v-card-title>
                  <v-card-text class="confirm-dialog-body">
                    <span v-if="isExcelFile">
                      This will assign targets to the employee from the uploaded Excel file for
                      <strong>{{ bulkFinancialYear }}</strong>. Once uploaded, another upload
                      for this employee will be skipped for this financial year.
                    </span>
                    <span v-else>
                      This will assign targets to employees from the uploaded ZIP file for
                      <strong>{{ bulkFinancialYear }}</strong>. Once uploaded, another bulk
                      upload for the same employee will be skipped for this financial year.
                    </span>
                    <br /><br />Continue?
                  </v-card-text>
                  <v-card-actions class="pb-4 px-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmDialog = false">Cancel</v-btn>
                    <v-btn color="#005f32" dark :loading="bulkUploading" @click="doUploadZip">Yes, Upload</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-card flat class="bulk-upload-section" style="background-color: transparent;">
                <v-layout wrap>
                  <!-- Financial Year -->
                  <v-flex xs12 align-self-center text-left pa-2 class="mb-2">
                    <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Financial Year</div>
                    <v-select
                      v-model="bulkFinancialYear"
                      :items="yearList"
                      item-text="name"
                      item-value="name"
                      outlined
                      dense
                      required
                      hide-details="auto"
                      placeholder="Select Financial Year"
                      prepend-inner-icon="mdi-calendar-blank-outline"
                    ></v-select>
                  </v-flex>

                  <!-- ZIP Upload Card -->
                  <v-flex xs12 align-self-center text-left pa-2 class="mb-2">
                    <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Target File</div>
                    <v-card outlined class="bulk-upload-card pa-3 mx-auto" :class="{ 'bulk-upload-card--error': zipFileError }" style="border-radius: 8px; background-color: #fafdfb; width: 100%;">
                      <v-layout wrap align-center>
                        <v-flex xs12 sm7 md8 align-self-center text-left pa-1>
                          <v-layout align-start style="flex-wrap: nowrap;">
                            <v-flex shrink align-self-start pr-3 pt-1>
                              <v-icon :color="uploadedFileName ? '#005f32' : '#90a4ae'" size="28px">
                                {{ isExcelFile ? 'mdi-file-excel' : 'mdi-folder-zip-outline' }}
                              </v-icon>
                            </v-flex>
                            <v-flex align-self-start class="bulk-file-name" style="flex: 1; min-width: 0;">
                              <div v-if="uploadedFileName">
                                <div class="bulk-file-title" style="color: #607d8b; font-size: 11px; margin-bottom: 2px;">SELECTED FILE</div>
                                <div class="d-flex align-center">
                                  <div class="bulk-file-name__text bulk-file-name__text--selected font-weight-bold" style="font-size: 15px; color: #1f2d24; max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="uploadedFileName">
                                    {{ uploadedFileName }}
                                  </div>
                                  <v-btn icon small @click="clearSelectedFile" :disabled="bulkUploading" title="Remove file" color="#e53935" class="ml-1" style="margin-top: -2px;">
                                    <v-icon size="20px">mdi-close-circle</v-icon>
                                  </v-btn>
                                </div>
                                <div class="mt-1 d-flex flex-wrap align-center">
                                  <v-chip small color="#e8f5e9" text-color="#005f32" class="font-weight-bold mr-2" style="font-family: kumbhMedium; height: 24px; font-size: 12px;">
                                    <v-icon left size="14">mdi-check-circle-outline</v-icon>
                                    {{ isExcelFile ? 'Excel Upload' : 'ZIP Upload' }}
                                  </v-chip>
                                  <v-chip v-if="previewData && previewData.type === 'zip'" small color="#e3f2fd" text-color="#1565c0" class="font-weight-bold" style="font-family: kumbhMedium; height: 24px; font-size: 12px;">
                                    <v-icon left size="14">mdi-file-multiple</v-icon>
                                    Files: {{ previewData.totalFiles }}
                                  </v-chip>
                                </div>
                              </div>
                              <div v-else class="mt-1">
                                <span class="bulk-file-name__text" style="color: #78909c; font-size: 15px;">No file selected</span>
                                <div class="bulk-helper-text mt-2" style="font-size: 13px; color: #90a4ae; line-height: 1.5;">
                                  • ZIP for multiple employees<br/>
                                  • Excel for single employee
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm5 md4 align-self-center text-right pa-1>
                          <v-layout justify-end align-center style="flex-wrap: nowrap;">
                            <v-btn 
                              color="#005f32" 
                              dark 
                              depressed
                              class="rounded-pill px-5 text-capitalize font-weight-bold" 
                              @click="$refs.bulkTargetZip.click()" 
                              :disabled="bulkUploading"
                              style="letter-spacing: 0.5px; height: 38px;"
                            >
                              <v-icon left size="18">mdi-folder-search-outline</v-icon>
                              Browse Files
                            </v-btn>
                            <input
                              v-show="false"
                              ref="bulkTargetZip"
                              type="file"
                              accept=".zip,.xlsx"
                              @change="handleBulkZipUpload"
                            />
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="zipFileError" wrap>
                        <v-flex xs12 pa-1>
                          <span class="zip-error-text font-weight-bold ml-11">{{ zipFileError }}</span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <!-- Upload Progress -->
                  <v-flex xs12 pa-2 v-if="bulkUploading">
                    <v-card class="upload-progress-card pa-4" flat outlined>
                      <v-layout wrap align-center>
                        <v-flex shrink pr-3>
                          <v-progress-circular indeterminate color="#005f32" size="32"></v-progress-circular>
                        </v-flex>
                        <v-flex>
                          <span class="upload-status-text">{{ uploadStatusText }}</span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>



                  <!-- Submit Button -->
                  <v-flex xs12 align-self-center text-center pa-2 mt-2 v-if="previewData && !zipFileError && !previewLoading">
                    <v-btn
                      color="#005f32"
                      dark
                      large
                      class="rounded-pill px-8"
                      style="font-family: kumbhMedium; font-size: 15px; letter-spacing: 0.5px; text-transform: none;"
                      :disabled="!uploadedFileName || !bulkFinancialYear || bulkUploading"
                      :loading="bulkUploading"
                      @click="confirmDialog = true"
                    >
                      <v-icon left size="20">mdi-cloud-upload</v-icon>
                      Upload Targets
                    </v-btn>
                  </v-flex>
                </v-layout>

                <!-- Upload Result Summary -->
                <div v-if="uploadResult" class="upload-result-section" ref="uploadResult">
                  <v-divider class="my-4"></v-divider>
                  <div class="result-heading">Upload Summary</div>

                  <!-- Summary Cards -->
                  <v-layout wrap pa-2>
                    <v-flex xs6 sm3 md3 pa-2>
                      <v-card class="summary-card summary-card--total" flat>
                        <div class="summary-card__value">{{ uploadResult.totalFiles || 0 }}</div>
                        <div class="summary-card__label">Total Files</div>
                      </v-card>
                    </v-flex>
                    <v-flex xs6 sm3 md3 pa-2>
                      <v-card class="summary-card summary-card--success" flat>
                        <div class="summary-card__value">{{ uploadResult.successCount || 0 }}</div>
                        <div class="summary-card__label">Successful</div>
                      </v-card>
                    </v-flex>
                    <v-flex xs6 sm3 md3 pa-2>
                      <v-card class="summary-card summary-card--failed" flat>
                        <div class="summary-card__value">{{ uploadResult.failedCount || 0 }}</div>
                        <div class="summary-card__label">Failed</div>
                      </v-card>
                    </v-flex>
                    <v-flex xs6 sm3 md3 pa-2>
                      <v-card class="summary-card summary-card--skipped" flat>
                        <div class="summary-card__value">{{ uploadResult.skippedCount || 0 }}</div>
                        <div class="summary-card__label">Skipped Employees</div>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <!-- Success Employees Table -->
                  <div v-if="uploadResult.successEmployees && uploadResult.successEmployees.length" class="result-table-section">
                    <div class="result-table-heading result-table-heading--success">Successfully Uploaded</div>
                    <v-simple-table dense class="result-table">
                      <thead><tr><th>Employee ID</th><th>Uploaded Targets Count</th></tr></thead>
                      <tbody>
                        <tr v-for="(item, i) in uploadResult.successEmployees" :key="'succ'+i">
                          <td>{{ item.employeeId }}</td>
                          <td>{{ item.targetsInserted }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <!-- Failed Employees Table -->
                  <div v-if="uploadResult.failedEmployees && uploadResult.failedEmployees.length" class="result-table-section">
                    <div class="result-table-heading result-table-heading--failed">Failed Employees</div>
                    <v-simple-table dense class="result-table">
                      <thead><tr><th>Employee ID</th><th>Reason</th></tr></thead>
                      <tbody>
                        <tr v-for="(item, i) in uploadResult.failedEmployees" :key="'f'+i">
                          <td>{{ item.employeeId }}</td>
                          <td>{{ item.reason }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <!-- Skipped Employees Table -->
                  <div v-if="uploadResult.skippedEmployees && uploadResult.skippedEmployees.length" class="result-table-section">
                    <div class="result-table-heading result-table-heading--skipped">Skipped Employees</div>
                    <v-simple-table dense class="result-table">
                      <thead><tr><th>Employee ID</th><th>Reason</th></tr></thead>
                      <tbody>
                        <tr v-for="(item, i) in uploadResult.skippedEmployees" :key="'s'+i">
                          <td>{{ item.employeeId }}</td>
                          <td>{{ item.reason }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <!-- Duplicate Targets Table -->
                  <div v-if="uploadResult.skippedDuplicateTargets && uploadResult.skippedDuplicateTargets.length" class="result-table-section">
                    <div class="result-table-heading result-table-heading--duplicate">Duplicate Targets Skipped</div>
                    <v-simple-table dense class="result-table">
                      <thead><tr><th>Employee ID</th><th>Target</th><th>Reason</th></tr></thead>
                      <tbody>
                        <tr v-for="(item, i) in uploadResult.skippedDuplicateTargets" :key="'d'+i">
                          <td>{{ item.employeeId }}</td>
                          <td style="white-space: pre-wrap;">{{ item.target }}</td>
                          <td>{{ item.reason }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </v-card>
            </v-tab-item>

            <v-tab-item value="single-target-tab">
              <v-card flat style="background-color: transparent;">
                <v-form v-model="valid" ref="form">
                  <v-layout wrap>
                    <v-flex xs12 sm6 align-self-center text-left pa-2 class="mb-4">
                      <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Select Employee</div>
                      <v-autocomplete
                        v-model="selectedEmployee"
                        :items="empList"
                        :item-text="employeeLabel"
                        item-value="_id"
                        :search-input.sync="employeeSearch"
                        placeholder="Search and select employee..."
                        prepend-inner-icon="mdi-account-search-outline"
                        no-filter
                        required
                        return-object
                        outlined
                        dense
                        hide-details="auto"
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 align-self-center text-left pa-2 class="mb-4">
                      <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Financial Year</div>
                      <v-select
                        v-model="financialYear"
                        :items="yearList"
                        item-text="name"
                        item-value="name"
                        outlined
                        dense
                        required
                        placeholder="Select Financial Year"
                        prepend-inner-icon="mdi-calendar-blank-outline"
                        hide-details="auto"
                        :rules="[rules.required]"
                      >
                      </v-select>
                    </v-flex>

                    <v-flex xs12 pa-2 class="mt-2 mb-2">
                      <span class="font-weight-bold" style="font-size: 16px; color: #005f32; font-family: kumbhMedium; display: block; border-bottom: 2px solid #e8f0ec; padding-bottom: 8px;">
                        Targets Details
                      </span>
                    </v-flex>

                    <v-flex xs12 v-for="(item, index) in targetsList" :key="index" pa-2 class="target-item-container mb-2">
                      <v-card outlined class="pa-4 position-relative target-item-card" style="border-radius: 12px; border: 1px solid #e2ebd5 !important;">
                        <div class="target-card-header d-flex justify-space-between align-center mb-4">
                          <span class="target-row-number font-weight-bold" style="color: #005f32; font-family: kumbhMedium; font-size: 13px; background: #e8f3ee; padding: 4px 12px; border-radius: 20px;">
                            Target #{{ index + 1 }}
                          </span>
                          <v-btn icon color="#e53935" small @click="removeTargetRow(index)" v-if="targetsList.length > 1" title="Remove Target">
                            <v-icon size="18px">mdi-delete-outline</v-icon>
                          </v-btn>
                        </div>
                        <v-layout wrap>
                          <v-flex xs12 align-self-center text-left pa-2>
                            <div style="font-family: kumbhBold; font-size: 14px; color: #333; margin-bottom: 6px;">Target Description</div>
                            <v-textarea
                              v-model="item.target"
                              placeholder="Enter target description..."
                              required
                              outlined
                              dense
                              rows="2"
                              hide-details="auto"
                              color="#005f32"
                              :rules="[rules.required]"
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2>
                            <div style="font-family: kumbhBold; font-size: 14px; color: #333; margin-bottom: 6px;">Target Date</div>
                            <v-dialog
                              v-model="item.menu"
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="item.targetDate"
                                  placeholder="Select target date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  outlined
                                  dense
                                  hide-details="auto"
                                  color="#005f32"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules="[rules.required]"
                                ></v-text-field>
                              </template>
                              <v-date-picker color="#005f32"
                                v-model="item.targetDate"
                                :min="targetDateMin"
                                :max="targetDateMax"
                                @input="item.menu = false"
                              ></v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2>
                            <div style="font-family: kumbhBold; font-size: 14px; color: #333; margin-bottom: 6px;">Target Weightage</div>
                            <v-text-field
                              v-model="item.targetWeightage"
                              placeholder="e.g. 10"
                              required
                              outlined
                              type="number"
                              min="0.01"
                              max="100"
                              dense
                              hide-details="auto"
                              color="#005f32"
                              :rules="[rules.required, rules.weightage]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 pa-2 class="d-flex justify-center my-3">
                      <v-btn color="#005f32" outlined class="rounded-pill px-6" @click="addNewTargetRow" style="font-family: kumbhMedium; text-transform: none; font-size: 13px; letter-spacing: 0.5px;">
                        <v-icon left size="18">mdi-plus-circle</v-icon>
                        Add Target Row
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap mt-2>
                    <v-flex xs12 align-self-center text-center pa-2>
                      <v-btn
                        color="#005f32"
                        dark
                        large
                        class="rounded-pill px-8"
                        style="font-family: kumbhMedium; font-size: 15px; letter-spacing: 0.5px; text-transform: none;"
                        @click="validateInput()"
                      >
                        <v-icon left size="20">mdi-send-check</v-icon>
                        Submit Targets
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <!-- </v-dialog> -->

        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import JSZip from "jszip";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      valid: false,
      targetTab: "bulk-upload-tab",
      appLoading: false,
      targetsList: [
        {
          target: "",
          targetDate: "",
          targetWeightage: "",
          menu: false
        }
      ],
      targetSheet: null,
      uploadedFileName: "",
      isExcelFile: false,
      zipFileError: "",
      confirmDialog: false,
      bulkUploading: false,
      uploadStatusText: "Uploading ZIP...",
      uploadResult: null,
      previewData: null,
      previewLoading: false,
      selectedEmployee: null,
      empList: [],
      employeeSearch: "",
      employeeSearchTimeout: null,
      financialYear: null,
      bulkFinancialYear: null,
      yearList: [],
      menu: false,
      rules: {
        required: (value) => !!value || "Required.",
        weightage: (value) => {
          const numericValue = Number(value);
          return (Number.isFinite(numericValue) && numericValue > 0 && numericValue <= 100)
            || "Enter a value greater than 0 and no more than 100.";
        },
      },
    };
  },
  mounted() {
    this.getyear();
    this.getEmp();
    this.getLatestBulkUploadSummary();
  },
  watch: {
    employeeSearch() {
      if (this.employeeSearchTimeout) clearTimeout(this.employeeSearchTimeout);
      this.employeeSearchTimeout = setTimeout(() => {
        this.getEmp();
      }, 400);
    },
  },
  computed: {
    targetDateMin() {
      if (!this.financialYear) return undefined;
      const [startYear] = this.financialYear.split("-").map(Number);
      return Number.isFinite(startYear) ? `${startYear}-04-01` : undefined;
    },
    targetDateMax() {
      if (!this.financialYear) return undefined;
      const [, endYear] = this.financialYear.split("-").map(Number);
      if (!Number.isFinite(endYear)) return undefined;
      const lastDay = new Date(endYear, 2, 0).getDate();
      return `${endYear}-02-${String(lastDay).padStart(2, "0")}`;
    },
  },
  methods: {
    getLatestBulkUploadSummary() {
      axios({
        method: "GET",
        url: "/admin/targets/latest-bulk-upload-summary",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status && response.data.data) {
            this.uploadResult = response.data.data;
          }
        })
        .catch((err) => {
          console.error("Failed to load latest upload summary from DB:", err);
        });
    },
    validateInput() {
      const totalWeightage = this.targetsList.reduce(
        (sum, item) => sum + (Number(item.targetWeightage) || 0),
        0
      );
      if (totalWeightage > 100) {
        this.msg = `Total target weightage cannot exceed 100 (current total: ${totalWeightage}).`;
        this.showsnackbar = true;
        return;
      }
      if (this.$refs.form.validate()) {
        this.addTarget();
      } else {
        this.msg = "Please fill all required fields";
        this.showsnackbar = true;
      }
    },
    addNewTargetRow() {
      this.targetsList.push({
        target: "",
        targetDate: "",
        targetWeightage: "",
        menu: false
      });
    },
    removeTargetRow(index) {
      if (this.targetsList.length > 1) {
        this.targetsList.splice(index, 1);
      }
    },
    addTarget() {
      this.appLoading = true;
      axios({
        url: "/employee/targetSheet/add",
        method: "POST",
        data: {
          targets: this.targetsList.map((item) => ({
            target: item.target,
            targetDate: item.targetDate,
            targetWeightage: item.targetWeightage
          })),
          financialYear: this.financialYear,
          employeeId: this.selectedEmployee._id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push("/Targets/myTarget");
            this.$refs.form.reset();
            this.targetsList = [
              {
                target: "",
                targetDate: "",
                targetWeightage: "",
                menu: false
              }
            ];
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Something went wrong";
          this.showsnackbar = true;
          console.log(err);
        });
    },

    clearSelectedFile() {
      this.targetSheet = null;
      this.uploadedFileName = "";
      this.isExcelFile = false;
      this.zipFileError = "";
      this.previewData = null;
      if (this.$refs.bulkTargetZip) {
        this.$refs.bulkTargetZip.value = "";
      }
    },

    async handleBulkZipUpload(event) {
      const file = event.target.files ? event.target.files[0] : null;
      this.zipFileError = "";
      this.previewData = null;

      if (!file) {
        this.zipFileError = "No file selected.";
        return;
      }

      const isZip = file.type === "application/zip" ||
        file.type === "application/x-zip-compressed" ||
        /\.zip$/i.test(file.name);

      const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        /\.xlsx$/i.test(file.name);

      if (!isZip && !isExcel) {
        this.zipFileError = "Only ZIP or Excel files are allowed";
        if (this.$refs.bulkTargetZip) this.$refs.bulkTargetZip.value = "";
        return;
      }

      this.isExcelFile = isExcel;
      this.targetSheet = file;
      this.uploadedFileName = file.name;

      if (isZip) {
        await this.generateZipPreview(file);
      } else if (isExcel) {
        this.generateExcelPreview(file);
      }
    },

    async generateZipPreview(file) {
      this.previewLoading = true;
      try {
        const zip = new JSZip();
        const loadedZip = await zip.loadAsync(file);
        
        let totalFiles = 0;
        let excelFiles = 0;
        let invalidCount = 0;
        let duplicateCount = 0;
        const employeeIds = [];
        const seenFilenames = new Set();
        let hasExcel = false;

        loadedZip.forEach((relativePath, zipEntry) => {
          if (!zipEntry.dir) {
            totalFiles++;
            const filename = zipEntry.name.split('/').pop();
            
            // ignore hidden files / macos files
            if (filename.startsWith('.') || relativePath.includes('__MACOSX')) {
               totalFiles--;
               return; 
            }

            if (/\.xlsx$/i.test(filename)) {
              excelFiles++;
              hasExcel = true;
              if (seenFilenames.has(filename.toLowerCase())) {
                duplicateCount++;
              } else {
                seenFilenames.add(filename.toLowerCase());
                const empId = filename.replace(/\.xlsx$/i, '');
                employeeIds.push(empId);
              }
            } else {
              invalidCount++;
            }
          }
        });

        if (!hasExcel) {
           this.zipFileError = "No Excel files found inside ZIP";
           this.previewData = null;
        } else {
           this.previewData = {
              type: "zip",
              filename: file.name,
              totalFiles,
              excelFiles,
              invalidCount,
              duplicateCount,
              employeeIds: employeeIds.slice(0, 10) // Show up to 10 for preview
           };
        }
      } catch (err) {
        this.zipFileError = "Invalid or corrupted ZIP file";
        this.previewData = null;
      } finally {
        this.previewLoading = false;
        if (this.$refs.bulkTargetZip) this.$refs.bulkTargetZip.value = "";
      }
    },

    generateExcelPreview(file) {
      const empId = file.name.replace(/\.xlsx$/i, '');
      this.previewData = {
        type: "excel",
        filename: file.name,
        employeeId: empId
      };
      if (this.$refs.bulkTargetZip) this.$refs.bulkTargetZip.value = "";
    },

    doUploadZip() {
      this.confirmDialog = false;
      this.uploadResult = null;
      this.zipFileError = "";

      if (!this.bulkFinancialYear) {
        this.msg = "Please choose a financial year.";
        this.showsnackbar = true;
        return;
      }
      if (!this.targetSheet) {
        this.msg = "Please select a ZIP file.";
        this.showsnackbar = true;
        return;
      }

      const formData = new FormData();
      formData.append("bulkZip", this.targetSheet);
      formData.append("financialYear", this.bulkFinancialYear);

      this.bulkUploading = true;
      this.uploadStatusText = "Uploading file...";

      const statusTimer = setTimeout(() => {
        this.uploadStatusText = "Processing data...";
      }, 3000);

      axios({
        method: "POST",
        url: "/admin/targets/bulk-upload-zip",
        data: formData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        timeout: 120000,
      })
        .then((response) => {
          clearTimeout(statusTimer);
          this.bulkUploading = false;
          this.uploadStatusText = "Upload completed";

          if (response.data.status === true || response.data.status === "true") {
            this.uploadResult = response.data;
            this.msg = `Upload complete: ${response.data.successCount || 0} succeeded, ${response.data.failedCount || 0} failed.`;
            this.targetSheet = null;
            this.uploadedFileName = "";
            if (this.$refs.bulkTargetZip) this.$refs.bulkTargetZip.value = "";
            this.$nextTick(() => {
              if (this.$refs.uploadResult) {
                this.$refs.uploadResult.scrollIntoView({ behavior: "smooth" });
              }
            });
          } else {
            this.msg = this.getApiMessage(response, "Bulk upload failed.");
          }
          this.showsnackbar = true;
        })
        .catch((err) => {
          clearTimeout(statusTimer);
          this.bulkUploading = false;
          if (err.code === "ECONNABORTED" || (err.message && err.message.includes("timeout"))) {
            this.msg = "Upload timed out. The ZIP file may be too large. Please try again.";
          } else if (err.response && err.response.status === 413) {
            this.msg = "Invalid ZIP file or file is too large.";
          } else {
            this.msg = this.getApiErrorMessage(err, "Network error. Please check your connection and try again.");
          }
          this.showsnackbar = true;
          console.error(err);
        });
    },

    getApiMessage(response, fallback) {
      const message = response && response.data && (response.data.msg || response.data.message);
      return message || fallback;
    },

    getApiErrorMessage(err, fallback) {
      const message = err && err.response && err.response.data && (err.response.data.msg || err.response.data.message);
      return message || fallback;
    },

    employeeLabel(item) {
      if (!item) return "";
      return item.employeeId ? `${item.name} (${item.employeeId})` : item.name;
    },

    getEmp() {
      axios({
        url: "/employees/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.employeeSearch,
          page: 1,
          limit: 1000,
        },
      })
        .then((response) => {
          const employees = response.data.data || [];
          if (
            this.selectedEmployee &&
            !employees.some((employee) => employee._id === this.selectedEmployee._id)
          ) {
            employees.unshift(this.selectedEmployee);
          }
          this.empList = employees;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getyear() {
      axios({
        method: "get",
        url: "/financialyear/getlist",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.yearList = response.data.data;
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth(); // 0-11
            let defaultFinancialYear;
            if (currentMonth < 3) {
              // Before April (Jan, Feb, Mar)
              defaultFinancialYear = `${currentYear - 1}-${currentYear}`;
            } else {
              // April onwards
              defaultFinancialYear = `${currentYear}-${currentYear + 1}`;
            }
            this.financialYear = defaultFinancialYear;
            this.bulkFinancialYear = defaultFinancialYear;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.target-tabs-card {
  padding-top: 4px;
}

.target-tabs-card >>> .v-tabs-bar {
  border-bottom: 1px solid #eef1ef;
}

.target-tabs-card >>> .v-tab {
  font-family: kumbhMedium;
  letter-spacing: 0;
  text-transform: none;
}

.bulk-upload-section {
  min-height: 190px;
}

.bulk-upload-card {
  border-color: #d8e2dc !important;
  border-radius: 6px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.bulk-upload-card:hover {
  border-color: #005f32 !important;
  box-shadow: 0 2px 10px rgba(0, 95, 50, 0.08);
}

.bulk-file-name {
  min-width: 0;
}

.bulk-file-name__text {
  color: #333;
  display: block;
  font-family: kumbhRegular;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bulk-file-name__text--selected {
  color: #1f2d24;
  font-family: kumbhMedium;
}

.bulk-file-title {
  font-size: 11px;
  color: #546e7a;
  font-family: kumbhMedium;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.bulk-file-badge {
  display: inline-block;
  color: #005f32;
  font-size: 11px;
  font-weight: bold;
  background-color: #e8f5e9;
  padding: 2px 8px;
  border-radius: 12px;
  margin-top: 4px;
  margin-bottom: 2px;
  font-family: kumbhMedium;
}

.bulk-file-subbadge {
  display: inline-block;
  color: #005f32;
  font-size: 11px;
  font-weight: bold;
  background-color: #e8f5e9;
  padding: 2px 8px;
  border-radius: 12px;
  margin-top: 4px;
  margin-bottom: 2px;
  margin-left: 4px;
  font-family: kumbhMedium;
}

.bulk-upload-card--error {
  border-color: #d32f2f !important;
}

.bulk-helper-text {
  color: #78909c;
  display: block;
  font-family: kumbhRegular;
  font-size: 11px;
  margin-top: 2px;
}

.zip-error-text {
  color: #d32f2f;
  font-family: kumbhRegular;
  font-size: 12px;
}

.upload-progress-card {
  border-color: #c8e6c9 !important;
  background: #f1f8e9 !important;
  border-radius: 6px;
}

.upload-status-text {
  color: #2e7d32;
  font-family: kumbhMedium;
  font-size: 14px;
}

.upload-result-section {
  padding: 4px 8px 16px;
}

.result-heading {
  color: #1f2d24;
  font-family: kumbhMedium;
  font-size: 16px;
  padding: 4px 8px 12px;
}

.summary-card {
  border-radius: 8px !important;
  padding: 14px 10px;
  text-align: center;
}

.summary-card--total  { background: #eceff1 !important; }
.summary-card--success { background: #e8f5e9 !important; }
.summary-card--failed  { background: #ffebee !important; }
.summary-card--skipped { background: #fff8e1 !important; }
.summary-card--duplicate { background: #fce4ec !important; }

.summary-card__value {
  font-family: kumbhMedium;
  font-size: 22px;
  line-height: 1.2;
}

.summary-card--total   .summary-card__value { color: #546e7a; }
.summary-card--success .summary-card__value { color: #2e7d32; }
.summary-card--failed  .summary-card__value { color: #c62828; }
.summary-card--skipped .summary-card__value { color: #f57f17; }
.summary-card--duplicate .summary-card__value { color: #ad1457; }

.summary-card__label {
  color: #607d8b;
  font-family: kumbhRegular;
  font-size: 11px;
  margin-top: 4px;
}

.result-table-section {
  margin: 12px 8px;
}

.result-table-heading {
  border-radius: 4px;
  font-family: kumbhMedium;
  font-size: 13px;
  margin-bottom: 6px;
  padding: 6px 10px;
}

.result-table-heading--success  { background: #e8f5e9; color: #2e7d32; }
.result-table-heading--failed   { background: #ffebee; color: #c62828; }
.result-table-heading--skipped  { background: #fff8e1; color: #f57f17; }
.result-table-heading--duplicate { background: #fce4ec; color: #ad1457; }

.result-table {
  border: 1px solid #eceff1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.result-table >>> th {
  text-align: center !important;
  font-family: kumbhMedium;
  font-size: 13px !important;
  color: #37474f !important;
  background-color: #f8fafc !important;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0 !important;
  height: 44px !important;
}

.result-table >>> td {
  text-align: center !important;
  font-family: kumbhRegular;
  font-size: 13px;
  color: #455a64;
  height: 48px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.result-table >>> tbody tr:hover {
  background-color: #f8fafc !important;
}

.confirm-dialog-title {
  font-family: kumbhMedium;
  font-size: 16px !important;
  color: #e65100;
}

.confirm-dialog-body {
  font-family: kumbhRegular;
  font-size: 14px;
  color: #37474f;
}

.target-item-card {
  background-color: #fafdfb !important;
  border-left: 4px solid #005f32 !important;
}
</style>
